// extracted by mini-css-extract-plugin
module.exports = {"sider_box":"sider_box-1eKNdVgQ","sider":"sider-2DsdK3Zd","stock_box":"stock_box-WKzq0FfW clearfix","sider_list":"sider_list-3R4HQ9jM"};